var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "main",
      {
        staticClass:
          "gfu-project-description-section gfu-project-description-section--emphasized js-main-content",
        attrs: {
          "data-qa": `project-description-section:${_vm.projectDescriptionSectionId}`,
        },
      },
      [
        _c(
          "div",
          {
            staticClass:
              "gfu-layout-wrapper gfu-layout-wrapper--extranarrow gfu-4of5--l gfu-3of5--xl",
          },
          [
            _c(
              "h2",
              {
                ref: "header",
                staticClass: "gfu-hd gfu-hd--h2 gfu-heading--top-divider _mb-2",
                attrs: {
                  "data-qa": `project-description-section-title:${_vm.header}`,
                },
              },
              [_vm._v("\n            " + _vm._s(_vm.header) + "\n        ")]
            ),
            _vm._v(" "),
            _vm.isLanguageSelectorVisible
              ? _c("project-section-story-available-languages", {
                  attrs: { "available-languages": _vm.availableLanguages },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("project-section-story-properties", {
              attrs: {
                "project-tags": _vm.projectTags,
                "project-category": _vm.projectCategory,
                "project-properties": _vm.projectProperties,
              },
            }),
            _vm._v(" "),
            _vm.isBackingInformationSectionVisible
              ? _c("project-section-backing-information", {
                  attrs: {
                    "is-stretch-pay-enabled": _vm.isStretchPaySectionVisible,
                    "is-stable-pledge-enabled":
                      _vm.isStablePledgeSectionVisible,
                    "is-crowdfunding-risks-enabled":
                      _vm.isCrowdfundingRisksSectionVisible,
                    "project-original-type": _vm.projectOriginalType,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.content
              ? _c("richtext-article", {
                  ref: "content",
                  staticClass: "_mt-2",
                  attrs: { content: _vm.content },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }